import React from 'react';
import {
  NavigationButton,
  NavigationButtonText,
} from 'legacyComponents/buttons/styles';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { Icon } from 'components';

export const EscButton = withNamespaces()(({ onclick, hidden, small }) => (
  <Button onMouseDown={onclick} hidden={hidden} small={small} modal>
    <Icon name='close' />
    <Text>
      <Trans>esc</Trans>
    </Text>
  </Button>
));

const Button = styled(NavigationButton)`
  position: absolute;
  top: 24px;
  right: ${props => (props.small ? '5px' : '0px')};
  display: ${props => (props.hidden ? 'none' : 'block')};
  &:hover {
    > span:nth-of-type(1) {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  ${media.s`
    transform: scale(0.8);
    right: ${props => (props.small ? '0px' : '0px')};
  `};
`;

const Text = styled(NavigationButtonText)`
  color: ${props => props.theme.color.wfWhite};
  left: 25px;
  top: 23px;
`;

EscButton.propTypes = {
  onclick: PropTypes.func,
  hidden: PropTypes.bool,
  small: PropTypes.bool,
};
